/* eslint-disable import/no-named-as-default, import/no-named-as-default-member */
import ACTION_TYPE from '../../store/ACTION_TYPE';
import * as trackers from './trackers';
import APP_SETTINGS_STATUS_ACTION from '../../enums/APP_SETTINGS_STATUS_ACTION';
import APP_SETTINGS_EDITORS_ACTION from '../../enums/APP_SETTINGS_EDITORS_ACTION';

let userInfo;
let eventBuffer = [];

const handlers = {
    [ACTION_TYPE.REQUEST_USER_FULFILLED]: ({ payload }) => {
        if (!userInfo && payload) {
            initialize(payload);
            track('visit_appstore', { referral: payload.ref });
        }
    },
    [ACTION_TYPE.TRACK]: ({ interaction }) => {
        track(`interaction_${interaction}`);
    },
    [ACTION_TYPE.UPDATE_APPS_FILTER]: ({ filterGroup, filter }) => {
        const filterName = Object.keys(filter)[0];
        track('update_filter', {
            type: filterGroup,
            name: filterName,
            value: filter[filterName],
        });
    },
    [ACTION_TYPE.REQUEST_APP]: ({ appId }) => {
        track('show_details', { appId });
    },
    [ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED]: ({
        payload: { appId, statusAction, editorsAction, wasTheAppSetAsDefault },
    }) => {
        switch (statusAction) {
            case APP_SETTINGS_STATUS_ACTION.ADD_APP:
                track('add_app', { appId });
                break;

            case APP_SETTINGS_STATUS_ACTION.REMOVE_APP:
                track('remove_app', { appId });
                break;

            case APP_SETTINGS_STATUS_ACTION.ENABLE_APP_ADD:
                track('enable_app', { appId, type: 'add', wasTheAppSetAsDefault });
                break;

            case APP_SETTINGS_STATUS_ACTION.CHANGE_DEFAULT:
                track('enable_app', { appId, wasTheAppSetAsDefault });
                break;

            case APP_SETTINGS_STATUS_ACTION.ENABLE_APP_ALLOW:
                track('enable_app', { appId, type: 'allow', wasTheAppSetAsDefault });
                break;

            case APP_SETTINGS_STATUS_ACTION.ENABLE_APP_GROUP:
                track('enable_app', { appId, type: 'group', wasTheAppSetAsDefault });
                break;

            case APP_SETTINGS_STATUS_ACTION.DISABLE_APP:
                track('disable_app', { appId });
                break;

            default:
                break;
        }
        // TODO here
        switch (editorsAction) {
            case APP_SETTINGS_EDITORS_ACTION.ENABLE_DEFAULT:
                track('enable_editors_default', { appId });
                break;

            case APP_SETTINGS_EDITORS_ACTION.DISABLE_DEFAULT:
                track('disable_editors_default', { appId });
                break;

            default:
                break;
        }
    },
    [ACTION_TYPE.OPEN_CONTROL_CENTER]: () => {
        track('open_control_center');
    },
    [ACTION_TYPE.OPEN_URL]: ({ appId }) => {
        track('open_app_url', { appId });
    },
    [ACTION_TYPE.OPEN_SETTINGS_INFO_POPUP]: ({ appId }) => {
        track('configure_app', { appId });
    },
    [ACTION_TYPE.TOGGLE_ADMIN_MODE]: () => {
        track('toggle_admin');
    },
    [ACTION_TYPE.CLICK_LINK]: ({ appId, url }) => {
        track('click_link', { appId, url });
    },
};

export default () => (next) => (action) => {
    handlers[action.type] && handlers[action.type](action);

    return next(action);
};

function initialize(userInfoData) {
    trackers.initialize(userInfoData);
    userInfo = userInfoData;
    flushEvents();
}

function flushEvents() {
    if (!eventBuffer || !trackers.ready()) {
        return;
    }
    eventBuffer.forEach(({ eventName, data }) => {
        trackers.track(eventName, data);
    });

    eventBuffer = null; // This should not be used again, ever
}

export function track(eventName, data) {
    data = data || {};

    if (!trackers.ready()) {
        // Not yet initialized, buffer for now
        eventBuffer.push({ eventName, data });
        flushEvents();
    } else {
        trackers.track(eventName, data);
    }
}
